import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { IdealeSection as Original } from 'components/organisms'
import { IdealeSectionSettings, IdealeSectionFloatingSettings } from './IdealeSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import {
  imageDefaultProps,
  imageItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'
import {
  layoutDefaultProps,
  layoutItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'
import { getTextEditor } from '../TextEditor'

export const defaultProps = {
  ...imageDefaultProps(),
  ...layoutDefaultProps(undefined, false),
  theme: 'light',
  primaryIcon: 'star',
}

export const idealeSectionParams = (enabled, id, blockProps, children) => {
  const hasLegacyCardGroupOnThirdNode = children?.[2]?.props?.type === 'idealeSection'
  const idealeTextFromEditor = hasLegacyCardGroupOnThirdNode
    ? null
    : getTextEditor(children?.[2], enabled)

  return {
    item: {
      ...imageItemParams(blockProps),
      ...layoutItemParams(blockProps),
      style: blockProps.theme,
      ctaLabel: idealeTextFromEditor,
      icon: blockProps.primaryIcon,
      pk: id,
      name: getTextEditor(children?.[0], enabled),
      description: getTextEditor(children?.[1], enabled),
    },
  }
}

export const dynamicProps = []

export const IdealeSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-ideale-section ${props.className}`}>
        <Original {...idealeSectionParams(enabled, id, blockProps, children)} editMode={enabled} />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

IdealeSection.craft = withCraft({
  name: 'IdealeSection',
  defaultProps: defaultProps,
  settings: IdealeSectionSettings,
  floatingSettings: IdealeSectionFloatingSettings,
})
